import { render, staticRenderFns } from "./fgv-list.vue?vue&type=template&id=50cc38a3"
import script from "./fgv-list.vue?vue&type=script&lang=ts"
export * from "./fgv-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports